import axiosBasicInstance from './../axiosConfig';

export const addEvents = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/user/add-events', data);
      return response;
   } catch (error) {
      throw error;
   }
};

export const editEvents = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/user/edit-events', data);
      return response;
   } catch (error) {
      throw error;
   }
};

export const getEvents = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/user/get-events', data);
      return response;
   } catch (error) {
      throw error;
   }
};

export const getEventsById = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/user/get-events-id', data);
      return response;
   } catch (error) {
      throw error;
   }
};

export const getInvitationById = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/user/get-invitations-id', data);
      return response;
   } catch (error) {
      throw error;
   }
};

export const getStaffById = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/user/get-staff-id', data);
      return response;
   } catch (error) {
      throw error;
   }
};

export const deleteEvents = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/user/delete-events', data);
      return response;
   } catch (error) {
      throw error;
   }
};

export const deleteStaff = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/user/delete-staff', data);
      return response;
   } catch (error) {
      throw error;
   }
};

export const addRegistration = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/user/add-registration', data);
      return response;
   } catch (error) {
      throw error;
   }
};

export const invitationAccepted = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/user/invitation-accepted', data);
      return response;
   } catch (error) {
      throw error;
   }
};

export const getEventsVisitors = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/user/get-events-visitors', data);
      return response;
   } catch (error) {
      throw error;
   }
};

export const getEventsVisitorsById = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/user/get-events-visitors-id', data);
      return response;
   } catch (error) {
      throw error;
   }
};

export const getEventsLogVisitorsById = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/user/get-events-log-visitors-id', data);
      return response;
   } catch (error) {
      throw error;
   }
};

export const deleteEventsVisitor = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/user/delete-events-visitors', data);
      return response;
   } catch (error) {
      throw error;
   }
};

export const deleteEventsLogVisitor = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/user/delete-events-log-visitors', data);
      return response;
   } catch (error) {
      throw error;
   }
};

export const getVisitors = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/user/get-visitors', data);
      return response;
   } catch (error) {
      throw error;
   }
};

export const deleteVisitor = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/user/delete-visitors', data);
      return response;
   } catch (error) {
      throw error;
   }
};

export const deleteVisitorInvitation = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/user/delete-invitations-id', data);
      return response;
   } catch (error) {
      throw error;
   }
};

export const getVisitorsCitizenId = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/user/get-visitors-citizenid', data);
      return response;
   } catch (error) {
      throw error;
   }
};

export const getVisitorsDetails = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/user/get-visitors-detail', data);
      return response;
   } catch (error) {
      throw error;
   }
};

export const addInvitation = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/user/add-invitations', data);
      return response;
   } catch (error) {
      throw error;
   }
};

export const getInvitation = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/user/get-invitations', data);
      return response;
   } catch (error) {
      throw error;
   }
};

export const getVisitorsEmail = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/user/get-visitors-email', data);
      return response;
   } catch (error) {
      throw error;
   }
};

export const eventApproved = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/user/event-accepted', data);
      return response;
   } catch (error) {
      throw error;
   }
};

export const eventRejected = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/user/event-rejected', data);
      return response;
   } catch (error) {
      throw error;
   }
};

export const eventSlots = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/user/event-slots', data);
      return response;
   } catch (error) {
      throw error;
   }
};

export const getEventsLogVisitors = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/user/get-events-log-visitors', data);
      return response;
   } catch (error) {
      throw error;
   }
};

export const addVisitorUser = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/user/add-visitor-user', data);
      return response;
   } catch (error) {
      throw error;
   }
};

export const updateVisitorUser = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/user/update-visitor-user', data);
      return response;
   } catch (error) {
      throw error;
   }
};

export const addEventsLogsVisitor = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/user/add-events-logs-visitors', data);
      return response;
   } catch (error) {
      throw error;
   }
};

export const exportVisitorsCSV = async (data) => {
   const response = await axiosBasicInstance.post(
     '/management/user/export-visitors',
     data,
     { responseType: 'blob' }
   );
   return response;
 };

 export const exportEventsCSV = async (data) => {
   const response = await axiosBasicInstance.post(
     '/management/user/export-events',
     data,
     { responseType: 'blob' }
   );
   return response;
 };

 export const exportEventsVisitorsCSV = async (data) => {
   const response = await axiosBasicInstance.post(
     '/management/user/export-events-visitors',
     data,
     { responseType: 'blob' }
   );
   return response;
 };

 export const exportEventsLogVisitorsCSV = async (data) => {
   const response = await axiosBasicInstance.post(
     '/management/user/export-events-log-visitors',
     data,
     { responseType: 'blob' }
   );
   return response;
 };